import {useLocation} from 'react-router-dom'
import { MyContainer } from '../../components/common/MyContainer';
import Footer from '../../components/footer';
import Header from '../../components/header';
import {
    SearchFormWrap,
    TotalResult,
    ViewMoreButton,
    ViewMoreIcon,
    PaddingLeft,
    PaddingRight
} from './searchElement'
import SearchForm from './searchForm'
import { BorderLine } from '../home/homeElements'
import newsApi from '../../api/newsApi'
import { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import NewsItem from '../../components/newsItem';
import NewsHotBox from '../../components/newsHotBox';
import Loading from '../../components/loading'

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const Search = () => {
    const [news, setNews] = useState([])
    const [total, setTotal] = useState(null)
    const [page, setPage] = useState(1)
    const query = useQuery()
    const q = query.get('q')
    const category = query.get('category')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const handleViewMore = async () => {
        try {
            setLoading(true)
            const response = await newsApi.search({ q, _page: page+1, category })
            
            if(response.success) {
                setPage(page+1)
                setNews([...news, ...response.news])
                setLoading(false)
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                const response = await newsApi.search({ q, category })
                if(response.success) {
                    setNews([...response.news])
                    setTotal(response.totalRows)
                    setPage(1)
                    setLoading(false)
                }
                
            } catch (error) {
                console.log(error)
                setLoading(false)
                setNews([])
                setTotal(0)
            }
        })()
    }, [q,category])


    return (
        <>
            <Header />
                <SearchFormWrap>
                    <MyContainer>
                        <SearchForm />
                    </MyContainer>
                </SearchFormWrap>
                <MyContainer>
                    <TotalResult>{total > 0 ? `${total} kết quả`:'Không tìm thấy bản tin cần tìm'}</TotalResult>
                    <BorderLine />
                    <Grid container>
                        <Grid item md={12} lg={6}>
                            <PaddingRight>
                                {news.map((news, index) => (
                                    <NewsItem smrow small key={news._id} news={news} />
                                ))}
                                {news.length < total && 
                                    <ViewMoreButton onClick={handleViewMore}>
                                        {loading ? 'Loading...':'Xem thêm'}
                                        <ViewMoreIcon />
                                    </ViewMoreButton>
                                }
                                {loading && <Loading />}
                            </PaddingRight>
                        </Grid>
                        
                        <Grid className='hide-on-mobile-tablet' item lg={6}>
                            <PaddingLeft>
                                <NewsHotBox sticky type='view' category={category} />
                            </PaddingLeft>
                        </Grid>
                    </Grid>
                </MyContainer>
            <Footer />
        </>
    )
}

export default Search
